import React, {useState} from 'react';
import useFindInstallmentPrices from "../../VIPiPhonePlan/hooks/useFindInstallmentPrices"
import {devicePrice} from "../../../services/vip.bundle.service";
import "./style.scss";
import ZaamPaymentSchedule from "./ZaamPaymentSchedule";
import Translations from "../../../services/translation";

const PaymentCardsWithZaam = ({savedPlan, sku, subscribeToZaam, subscribed}) => {
    const strings = Translations["keys"][Translations.activeLang];
   
    const {subscriptionPrice, installmentsArr} = useFindInstallmentPrices(sku);
    const [showModal, setShowModal] = useState(false);
   
    let oneTimePrice = devicePrice(savedPlan);

    const handleSubscriptionCardClick = (e) => {
        if(e.target.className.includes('more-info')){
            setShowModal(true);
        }else{
            subscribeToZaam(true);
        }
    }

  return <div className="device-payment-card-options-wrapper">
        <div className={`device-payment-card-option ${subscribed? '': 'selected'}`}
            onClick={()=>{
                subscribeToZaam(false);
            }}>
            <p className="price-title vmo-bold">{strings["BUNDLE_PLAN_PRICE_ONE_TIME_PAYMENT_TITLE"]}</p>
            <p className="amount vmo-bold">
                {strings["BUNDLE_PLAN_PRICE_ONE_TIME_PAYMENT_PRICE"]?.replace('%full_price%',oneTimePrice)}
                </p>
            <p className="note">{strings["BUNDLE_PLAN_PRICE_ONE_TIME_PAYMENT_NOTE"]}</p>
        </div>
        <div className={`device-payment-card-option ${subscribed? 'selected': ''}`}
            onClick={(e)=>{
                handleSubscriptionCardClick(e)
            }}>
            <p className="price-title vmo-bold">{strings["BUNDLE_PLAN_PRICE_ZAAM_TITLE"]}
                <span className="zaam-logo" />
            </p>
            <p className="amount vmo-bold">
                {strings["BUNDLE_PLAN_PRICE_ZAAM_PRICE"]?.replace('%price%', subscriptionPrice)}</p>
            <p className="note">{strings["BUNDLE_PLAN_PRICE_ZAAM_RENT_NOTICE"]}</p>
            <p className="more-info default-link vmo-bold">
                {strings["BUNDLE_PLAN_PRICE_ZAAM_MORE_INFO"]}
            </p>
        </div>
        {showModal && <ZaamPaymentSchedule close={()=>setShowModal(false)} installmentsArr={installmentsArr} savedPlan={savedPlan}/>}
    </div>
}

export default PaymentCardsWithZaam;